module.exports = __webpack_public_path__ + "static/media/Electricity.27be4b61.png";